/**
 * Hint card content for the Template Wizard.
 *
 * Keys correspond to `data-hint-field` attribute values on field wrappers.
 * Each entry has a `title` and `body` (supports markdown via MarkdownContent).
 *
 * For TemplateStructureStep, keys are SOAP section names:
 *   subjective, objective, assessment, plan, freeform
 * For TemplatePreferencesStep, the key is "userPreferences".
 */
export const WIZARD_HINT_CONTENT = {
  subjective: {
    title: "Subjective Section Tips",
    body: "TODO: Add best-practice guidance for the subjective section.",
  },
  objective: {
    title: "Objective Section Tips",
    body: "TODO: Add best-practice guidance for the objective section.",
  },
  assessment: {
    title: "Assessment Section Tips",
    body: "TODO: Add best-practice guidance for the assessment section.",
  },
  plan: {
    title: "Plan Section Tips",
    body: "TODO: Add best-practice guidance for the plan section.",
  },
  freeform: {
    title: "Template Content Tips",
    body: `1. **Use clear section headers** - Label every section explicitly (e.g., Subjective:, Vitals:, Plan:).

2. **Add short hints in parentheses** - After each header, nudge the AI: Meds: (Name, Dose, Frequency).

3. **Put your default normals in the template next to the corresponding body system** - If something should say "No lameness noted" when not discussed, put it here in parentheses to show the AI that it's a placeholder.

4. **Use "if mentioned" for optional details** - e.g., (Site of administration, if mentioned) prevents the AI from guessing.

5. **Build formatting into the template** - Want bullet points? Add a - directly rather than describing it in preferences.

6. **Match your PIMS** - Keep the same wording, order, and spacing you use in your actual records.`,
  },
  userPreferences: {
    title: "Writing Preferences Tips",
    body: "TODO: Add best-practice guidance for the preferences section.",
  },
};
